import * as React from 'react';
import PropTypes from 'prop-types';
import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import Heart from '../assets/heart.svg';
import GreyHeart from '../assets/greyHeart.svg';
import '../styles/sliderStyle.css';
import { useState } from 'react';
import { useEffect } from 'react';

const TipServiceSlider = styled(Slider)(({ theme }) => ({
    color: '#8E61E9',
    height: 0,
    '& .MuiSlider-thumb': {
        height: 0,
        width: 0,
    },
    '& .MuiSlider-rail': {
        color: '#d8d8d8',
        opacity: 1,
        height: 3,
    },
    '& .MuiSlider-track': {
        height: 3,
        border: 0
    },
}));

function AirbnbThumbComponent(props) {
    const { children, disabled, ...other } = props;
    return (
        <SliderThumb sx={{ PointerEvent: 'none !important' }} {...other}>
            {children}
            <img src={disabled ? GreyHeart : Heart} width={24} />
        </SliderThumb>
    );
}

AirbnbThumbComponent.propTypes = {
    children: PropTypes.node,
    value: PropTypes.number.isRequired,
    disabled: PropTypes.bool.isRequired
};

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip open={true}  {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#FFFFFF',
        color: '#000',
        height: '32px !important',
        width: '100% !important',
        padding: '10px',
        borderRadius: '8px',
        border: '1px solid #F7F7F7',
        boxShadow: theme.shadows[8],
        fontSize: 12,
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",

    },
}));
const formatPrice = (value) => {
    const floatValue = parseFloat(value);
    if ( floatValue >= 0 && floatValue.toString().split('.')[1]?.length === 1) {
      return floatValue.toFixed(2);
    }  else if (Number.isInteger(floatValue)) {
        return floatValue.toFixed(2);
      } else {
      return floatValue.toString();
    }
}
function ValueLabelComponent(props) {
    const { children, value, price, tooltipOpen, currencySymbol } = props;

    return (
        <LightTooltip open={tooltipOpen}
            enterTouchDelay={0} placement={value > 25 ? "top-start" : "top"}
            title={<div className='sub-head-3'> <span className='sub-head-2'>{price === 0 ? "" :`${currencySymbol}` +`${formatPrice(price)}`}</span> {`(${value}%)`}</div>} >
            {children}
        </LightTooltip>
    );
}

ValueLabelComponent.propTypes = {
    children: PropTypes.element.isRequired,
    value: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
    tooltipOpen: PropTypes.bool.isRequired,
    currencySymbol:PropTypes.element.isRequired
};


export default function SliderComponent({ setCreditApplied, setTotalAmount,setSliderValue,...props }) {



    const [tooltipOpen, setTooltipOpen] = useState(true);
    const [value, setValue] = useState(props?.sharedData?.donationAmount?.givesomeTipPercentage === 0 ? props?.sharedData?.donationAmount?.givesomeTipPercentage : 15);
    const [amount, setAmount] = useState();
    const [price, setPrice] = useState(0);
    const [thumbState, setThumbState] = useState();
    const [currencySymbol, setCurrencySymbol] = useState(props?.currencySymbol);

    useEffect(() => {
        setThumbState(props.disabled);
        setAmount(prevState => props.amount);
        setCreditApplied(prevState => props?.sharedData?.donationAmount?.creditApplied ? props.sharedData.donationAmount?.creditApplied : props?.amount  ? (props?.amount * (value / 100) ) :0.00 );
        // setSliderValue(prevState=> value);
        setPrice(prevState => props?.sharedData?.donationAmount?.creditApplied ? props.sharedData.donationAmount?.creditApplied : props?.amount  ? (props?.amount * (value / 100) ) :"");
        setTooltipOpen(true);
        handleChange(undefined, props.sliderValue);
        setCurrencySymbol(props?.currencySymbol);

    }, [props.disabled, props.amount,amount, props.currencySymbol]);

    const handleChange = (event, newValue) => {
        setValue(prevState =>  newValue);
        setPrice(prevState => (amount * ( newValue) / 100));
        setCreditApplied(preState => (amount * ( newValue) / 100));
        setTotalAmount(Number(props.amount) + Number((amount * ( newValue) / 100)));
        setSliderValue(prevState => newValue);
    };

    return (
        <Box sx={{ width: "100%", mt: '70px' }}>
            <Box sx={{ m: 3 }} />
            <TipServiceSlider
                id='slider'
                aria-label="Always visible"
                valueLabelDisplay={"on"}
                slots={{
                    thumb: (props) => <AirbnbThumbComponent {...props} disabled={thumbState} />,
                    valueLabel: (props) => <ValueLabelComponent {...props} price={price} tooltipOpen={tooltipOpen} currencySymbol={currencySymbol} />
                }}
                onChange={handleChange}
                getAriaLabel={(index) =>
                    index === 0 ? 'Minimum price' : 'Maximum price'
                }
                defaultValue={props?.sharedData?.donationAmount?.givesomeTipPercentage ? props?.sharedData?.donationAmount?.givesomeTipPercentage : props?.sharedData?.donationAmount?.givesomeTipPercentage === 0 ? 0 : 15}
                step={5}
                max={30}
                disabled={props.disabled}
            />
        </Box>
    );
}
